import React from "react";
import { Navigate } from "react-router-dom";
import { useRBAC } from "./RbacProvider";
import { rolePermissions } from "./RolePermission";
 
const ProtectedRoute = ({ element: Component, allowedKey }) => {
  const { role, permissions } = useRBAC();
 
  // Normalize role to ensure consistency
  const normalizedRole = (role || "").replace(/\s+/g, '');
 
  console.log('[LOG] ProtectedRoute - Role:', normalizedRole, 'AllowedKey:', allowedKey, 'Permissions:', permissions);
 
  // If no role (not authenticated), redirect to login
  if (!normalizedRole || normalizedRole.trim() === "") {
    console.log('[LOG] ProtectedRoute - No role found, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }
 
  // Check if user has access to this page
  if (permissions && permissions.sidebar && permissions.sidebar.includes(allowedKey)) {
    console.log('[LOG] ProtectedRoute - Access granted for', allowedKey);
    return Component;
  }
 
  // Otherwise redirect to clm_home (user doesn't have permission for this specific route)
  console.log('[LOG] ProtectedRoute - Access denied for', allowedKey, 'redirecting to clm_home');
  return <Navigate to="/clm_home" replace />;
};
 
export default ProtectedRoute;